export default postalOperators => postalOperators
  .filter(postalOperator =>
    postalOperator.users && postalOperator.users.length)
  .map((postalOperator) => {
    const childrenOperatorUser = postalOperator.users
      .map(operatorUser =>
        ({
          value: operatorUser.userId,
          label: `${operatorUser.userId} - ${operatorUser.userName}`,
        }));
    return {
      value: postalOperator.organisation,
      label: postalOperator.organisation.replace(/\r?\n/g, " ").replace(/\s+/g, " "),
      children: childrenOperatorUser,
    };
  });
